<template>
  <a-descriptions title="订单信息" :column="1">
    <a-descriptions-item label="订单状态">{{orderData.award_status_title}}</a-descriptions-item>
    <a-descriptions-item label="订单号">{{orderData.sn}}</a-descriptions-item>
    <a-descriptions-item label="收货信息">{{orderData.receiv_name}}，{{orderData.receiv_phone}}，{{orderData.receiv_area}}{{orderData.receiv_address}}</a-descriptions-item>
    <a-descriptions-item label="领取方式">{{orderData.receiv_type}}</a-descriptions-item>
    <a-descriptions-item label="发货门店" v-if="orderData.is_write==0">总部</a-descriptions-item>
    <a-descriptions-item label="核销门店" v-else>{{orderData.write_store_name}}</a-descriptions-item>
    <a-descriptions-item label="领奖时间">{{orderData.receiv_time}}</a-descriptions-item>
    <a-descriptions-item label="活动名称">{{orderData.activity_name}}</a-descriptions-item>
    <a-descriptions-item label="奖项名称">{{orderData.award_name}}</a-descriptions-item>
    <a-descriptions-item label="物流公司" v-if="orderData.is_write==0">{{orderData.express_name || '-'}} <a v-has:Logisticsinformation="()=>Logisticsinformation()" v-if="orderData.express_name" class="ml15">物流信息</a> </a-descriptions-item>
    <a-descriptions-item label="物流单号" v-if="orderData.is_write==0">{{orderData.express_code || '-'}}</a-descriptions-item>
    <a-descriptions-item label="发货时间" v-if="orderData.is_write==0">{{orderData.express_time || '-'}}</a-descriptions-item>
    <a-descriptions-item label="核销时间" v-else>{{orderData.write_time || '-'}}</a-descriptions-item>
    <a-descriptions-item label="备注" v-if="orderData.is_write==0">{{orderData.express_remark || '-'}}</a-descriptions-item>
  </a-descriptions>
  <a-descriptions class="m-t-20" title="买家信息" bordered layout="vertical">
    <a-descriptions-item label="微信昵称">{{orderData.member_name}}</a-descriptions-item>
    <a-descriptions-item label="会员ID">{{orderData.member_id}}</a-descriptions-item>
    <a-descriptions-item label="会员等级">{{orderData.member_vip_name}}</a-descriptions-item>
  </a-descriptions>
  <div class="m-t-20 m-b-20 fz-16 s_font_b">商品信息</div>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='orderData.award_info'>
    <template v-slot:gift_num="{ record }">
      <a v-if="orderData.redeem_code" @click="handelCodeDetail(orderData)">{{record.gift_num}}</a>
      <p v-else>{{record.gift_num}}</p>
    </template>
    <template v-slot:good="{ record }">
      <div class="s_flex_ali">
        <img class="table_img" :src="info.picdomain+(record.cover_image_url)" alt="">
        <p class="m-l-15" style="max-width:300px">{{record.gift_name}}</p>
      </div>
    </template>
  </a-table>
  <a-modal :keyboard="false" title="物流信息" :width='800' centered :footer="null" v-model:visible="showLogistics" destroyOnClose>
    <logisticsDetails :data='logisticsData' :type="1"></logisticsDetails>
  </a-modal>
  <a-modal :keyboard="false" centered v-model:visible="isTotal" :width='1200' :footer="null" destroyOnClose>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='name' :columns='columnscode' :data-source='data'>
    </a-table>
  </a-modal>
</template>
<script>
import { ref, reactive, toRefs, onMounted } from "vue";
import { getEntityMore, guideOrderLogistics } from "@/api/qrcodeActivitys";
import { iscode } from "@/utils/app";
import { message } from "ant-design-vue";
import store from "@/store";
import logisticsDetails from "../../components/logisticsDetails";

export default {
  components: { logisticsDetails },
  props: {
    scan_award_id: {
      type: Object,
    },
    sn_order: {
      type: Object,
    },
  },
  setup(props, { emit }) {
    let columns = [
      {
        title: "商品信息",
        key: "good",
        slots: { customRender: "good" },
      },
      {
        title: "数量",
        dataIndex: "gift_num",
        key: "gift_num",
        slots: { customRender: "gift_num" },
      },
      {
        title: "价格",
        dataIndex: "market_price",
        key: "market_price",
      },
    ];
    let columnscode = [
      {
        title: "兑换码",
        dataIndex: "redeem_code",
        key: "redeem_code",
      },
      {
        title: "状态",
        dataIndex: "status_text",
        key: "status_text",
        slots: { customRender: "status_text" },
      },
      {
        title: "添加时间",
        dataIndex: "redeem_code_time",
        key: "redeem_code_time",
      },
    ];
    const data = ref([]);
    const state = reactive({
      info: store.state.user.info,
      orderData: {},
      loading: false,
      showLogistics: false,
      logisticsData: {},
      isTotal: false,
      order_no: "",
    });
    const Logisticsinformation = () => {
      getLogistics();
    };

    const initData = async () => {
      let res = await getEntityMore(props.scan_award_id)
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(res)) {
        state.orderData = res.data;
      } else {
        message.error(res.message);
      }
    };
    //获取物流信息
    const getLogistics = async () => {
      let res = await guideOrderLogistics({ order_no: props.sn_order })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(res)) {
        state.showLogistics = true;
        state.logisticsData = res.data;
      } else {
        message.error(res.msg);
      }
    };
    const handelCodeDetail = (item) => {
    data.value.push({ redeem_code:item.redeem_code,
        redeem_code_time:item.redeem_code_time,
        status_text:'已发放'})
      state.isTotal = true;
    };

    onMounted(() => {
      initData();
    });
    return {
      ...toRefs(state),
      columns,
      Logisticsinformation,
      handelCodeDetail,
      columnscode,
      data,
    };
  },
};
</script>